import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SignatureGroupComponent } from './signature-group.component';
import { SignatureFieldModule } from './../signature-field/signature-field.module'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SignatureFieldModule,
    ],
    declarations: [SignatureGroupComponent],
    exports: [SignatureGroupComponent]
})
export class SignatureGroupModule { }
